import React from 'react';
import PropTypes from "prop-types";
import {useSearchParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";

import PerPage from "../PerPage";
import {setCurrentAction} from "./actions";

import './paginator.scss';

const Paginator = function ({entity = 'generic', show = true}) {
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const current = useSelector(state => state[entity + '_current']);
    const pages = useSelector(state => state[entity + '_pages']);

    const goPage = function (current) {
        searchParams.set('current', current);
        setSearchParams(searchParams);
        dispatch(setCurrentAction(entity, current));
    }
    const renderPages = function (pages) {
        let items = [];

        for (let i = 1; i <= pages; i++) {
            items.push(
                <li key={i} className={"page-item" + (i === current ? ' disabled' : '')}>
                    <a className="page-link" href="#" onClick={event => {
                        event.preventDefault();
                        if (i !== current) {
                            goPage(i);
                        }
                    }}>{i}</a>
                </li>
            )
        }

        return items;
    }
    if (show) {
        return (
            <nav aria-label="Bottom pagination" className='paginator'>
                <PerPage entity={entity}/>
                <ul className="pagination">
                    <li className={"page-item" + (current <= 1 ? ' disabled' : '')}>
                        <a className="page-link" href="#" aria-label="Previous"
                           onClick={event => {
                               event.preventDefault();
                               if (current > 1) {
                                   goPage(current - 1)
                               }
                           }}>
                            <span aria-hidden="true">&laquo;</span>
                        </a>
                    </li>
                    {renderPages(pages)}
                    <li className={"page-item" + (current >= pages ? ' disabled' : '')}>
                        <a className="page-link" href={"#"} aria-label="Next"
                           onClick={event => {
                               event.preventDefault();
                               if (current < pages) {
                                   goPage(current + 1);
                               }
                           }}>
                            <span aria-hidden="true">&raquo;</span>
                        </a>
                    </li>
                </ul>
            </nav>
        );
    }

    return null;
}

Paginator.propTypes = {
    entity: PropTypes.string,
    show: PropTypes.bool
};

export default Paginator;
